var map = {
	"./cable.png": "ff0d",
	"./cables.png": "4b42",
	"./construccion.png": "3fe9",
	"./electricidad.png": "4bdd",
	"./electronica.png": "6d72",
	"./ferreteria.png": "0893",
	"./herramienta.png": "ca21",
	"./hogar.png": "959f",
	"./iluminacion.png": "2d39",
	"./jardineria.png": "0fa4",
	"./pintura.png": "a8eb",
	"./plomeria.png": "b360",
	"./seguridad.png": "b0f4",
	"./ventilacion.png": "e147"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f2c8";